import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';

import { learningOpportunityKeys, learningOpportunityPathnames } from './query-keys';

export type UseDeleteLearningOpportunityMutationResult = UseMutationResult<void, Error, string>;

export const useDeleteLearningOpportunityMutation = (): UseDeleteLearningOpportunityMutationResult => {
    const { cobrainerApiFetcher } = useContext(ApplicationContext);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id: string) => {
            const result = await cobrainerApiFetcher.delete({
                pathname: learningOpportunityPathnames.detail(id),
            });

            if (result.isErr) {
                throw result.error;
            }
        },
        onSuccess: () => {
            queryClient.removeQueries({ queryKey: learningOpportunityKeys.details() });
            queryClient.invalidateQueries({ queryKey: learningOpportunityKeys.filter() });
        },
    });
};
